function ExecuteCommand(
  Data, // Данные команды
  successCallback, // Функция выполняемая при успешном соединении
  errorCallback, // Функция выполняемая при ошибке соединения
  timeout
) {
  // Проверка стоит ли расширение, и если стоит то отправка через расширение
  // Для активации скрипта расширения ваша страница должна содержать в теге "head" строку:
  // <script>var KkmServerAddIn = {};</script>
  try {
    if (KkmServer != undefined) {
      // Если данные - строка JSON конвентируем в объект
      if (typeof Data == "string") Data = JSON.parse(Data);
      // Выполняем команду через расширение
      let m = KkmServer.Execute(result, Data);
      //Возврат - вызов по Http не нужен
      function result(result) {
        let hasError = false;
        let MessageStatus = "";
        let MessageError;
        if (result.Status == 0) {
          MessageStatus = "Ok";
        } else if (result.Status == 1) {
          MessageStatus = "Выполняется";
        } else if (result.Status == 2) {
          hasError = true;
          MessageStatus = "Ошибка ККМ web-сервера!";
        } else if (result.Status == 3) {
          hasError = true;
          MessageStatus = "ККМ web-сервер: Данные не найдены!";
        }
        // Текст ошибки
        MessageError = result.Error;
        if (hasError) {
          errorCallback(MessageStatus + " " + MessageError);
        } else {
          successCallback(result);
        }
      }
      return;
    } else {
      errorCallback("KKMServer plugin not installed in your Browser!");
      return;
    }
  } catch (e) {
    if (!window.KkmServer) {
      errorCallback("KKMServer plugin didn't installed in current browser!");
    } else {
      errorCallback(e);
    }
  }
}

// Герерация GUID
function guid() {
  function S4() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  }
  return (
    S4() +
    S4() +
    "-" +
    S4() +
    "-" +
    S4() +
    "-" +
    S4() +
    "-" +
    S4() +
    S4() +
    S4()
  );
}

function KKMListDevices(result) {
  // Подготовка данных команды
  var Data = KkmServer.List();
  //console.log(Data);
  // Отбор по номеру устройства. Число. Если 0 или не указано то с любым номером
  //Data.NumDevice = 0;
  // Отбор по ИНН. Строка. Если "" или не указано то первое не блокированное на сервере
  //Data.InnKkm = "";
  // Отбор активных. Булево. Если null или не указано то активные и не активные
  //Data.Active = true;
  // Отбор выключенны-включенных
  Data.OnOff = true;
  // Отбор наличию ошибок ОФВ. Булево. Если null или не указано то с ошибками и без
  Data.OFD_Error = false;
  // Все у которых дата не переданного док. в ОФД меньше указанной. Дата-время. Если null или не указано то любое
  //Data.OFD_DateErrorDoc = '2100-01-01T00:00:00';
  Data.OFD_DateErrorDoc = null;
  // Все у которых дата окончания работы ФН меньше указанной. Дата-время. Если null или не указано то любое
  //Data.FN_DateEnd = '2100-01-01T00:00:00';
  // Все у которых заканчивается память ФН; Булево. Если null или не указано то все
  Data.FN_MemOverflowl = false;
  // Фискализированные или нет ФН; Булево. Если null или не указано то все
  //Data.FN_IsFiscal = true;
  Data.FN_IsFiscal = null;

  // Вызов команды
  let OldIdCommand = Data.Execute(result).IdCommand;


  return OldIdCommand;
  // Возвращается JSON:
  //{
  //    "ListUnit": [
  //          {
  //              "NumDevice": 2,
  //              "IdDevice": "6a6151a5-b352-485c-8f01-45da05d3df18",
  //              "OnOf": true,
  //              "Active": false,
  //              "TypeDevice": "Фискальный регистратор",
  //              "IdTypeDevice": "KkmStrihM",
  //              "IP": "192.168.137.111",
  //              "NameDevice": "<Не определено>",
  //              "KktNumber": "",
  //              "INN": "<Не определено>",
  //              "TaxVariant": "", // Описание смотри в команде KkmRegOfd
  //              "AddDate": "2017-01-13T14:55:16.9796533+03:00",
  //              "OFD_Error": "",
  //              "OFD_NumErrorDoc": 0,
  //              "OFD_DateErrorDoc": "0001-01-01T00:00:00",
  //              "FN_DateEnd": "0001-01-01T00:00:00",
  //              "FN_MemOverflowl": false,
  //              "FN_IsFiscal": false,
  //              "PaperOver": false
  //          },
  //    ],
  //    "Command": "List",
  //    "Error": "",  // Текст ошибки если была - обязательно показать пользователю - по содержанию ошибки можно в 90% случаях понять как ее устранять
  //    "Status": 0   // Ok = 0, Run(Запущено на выполнение) = 1, Error = 2, NotFound(устройство не найдено) = 3, NotRun = 4
  //}
}

/**
 * Функция для печати чека
 *
 * @param receiptLines
 * @param options
 * @param successCB
 * @param failCB
 * @constructor
 */
function KKMPrintReceipt(receiptLines, options, successCB, failCB) {
  let sum = 0;
  receiptLines.forEach((item) => {
    if (item.Register) {
      sum = sum + parseFloat(item.Register.Amount);
    }
  });
  sum = sum.toFixed(2);
  receiptLines.unshift({ PrintText: { Text: "<<*>>" } }); //строка из звездочек
  receiptLines.unshift(
    // Строка с печатью простого текста
    {
      PrintText: {
        Text: options.companyName,
        Font: 0,
      },
    }
  );
  receiptLines.unshift({ PrintText: { Text: "<<*>>" } }); //строка из звездочек
  let IsBarCode = false;
  // Подготовка данных команды
  let Data = {
    // Команда серверу
    Command: "RegisterCheck",

    //***********************************************************************************************************
    // ПОЛЯ ПОИСКА УСТРОЙСТВА
    //***********************************************************************************************************
    // Номер устройства. Если 0 то первое не блокированное на сервере
    NumDevice: options.numDevice,
    // ИНН ККМ для поиска. Если "" то ККМ ищется только по NumDevice,
    // Если NumDevice = 0 а InnKkm заполнено то ККМ ищется только по InnKkm
    InnKkm: options.InnKkm,
    //---------------------------------------------
    // Заводской номер ККМ для поиска. Если "" то ККМ ищется только по NumDevice,
    KktNumber: "",
    // **********************************************************************************************************

    // Время (сек) ожидания выполнения команды.
    //Если За это время команда не выполнилась в статусе вернется результат "NotRun" или "Run"
    //Проверить результат еще не выполненной команды можно командой "GetRezult"
    //Если не указано или 0 - то значение по умолчанию 60 сек.
    // Поле не обязательно. Это поле можно указывать во всех командах
    Timeout: 30,
    // Уникальный идентификатор команды. Любая строка из 40 символов - должна быть уникальна для каждой подаваемой команды
    // По этому идентификатору можно запросить результат выполнения команды
    // Поле не обязательно
    IdCommand: guid(),
    // Это фискальный или не фискальный чек
    IsFiscalCheck: true,

    // Тип чека, Тег 1054;
    // 0 – продажа/приход;                      10 – покупка/расход;
    // 1 – возврат продажи/прихода;             11 - возврат покупки/расхода;
    // 2 – корректировка продажи/прихода;       12 – корректировка покупки/расхода;
    TypeCheck: options.receiptType, //TypeCheck,
    // Не печатать чек на бумагу
    NotPrint: false, //true,
    // Количество копий документа
    NumberCopies: 0,
    // Продавец, Тег ОФД 1021
    CashierName: options.cashierName, //"Kазакова Н.А.",
    // ИНН продавца Тег ОФД 1203
    CashierVATIN: options.cashierINN, //"430601071197",
    // Телефон или е-Майл покупателя, Тег ОФД 1008
    // Если чек не печатается (NotPrint = true) то указывать обязательно
    // Формат: Телефон +{Ц} или Email {С}@{C}
    //ClientAddress: "sochi@papa.com",
    // Покупатель (клиент) - наименование организации или фамилия, имя, отчество (при наличии), серия и номер паспорта покупателя(клиента). Тег 1227
    // Только с использованием наличных / электронных денежных средств и при выплате выигрыша, получении страховой премии или при страховой выплате.
    //ClientInfo: "Везучий В.В. РЕ-125486",
    // ИНН Организации или покупателя(клиента). Тег 1228
    // Только с использованием наличных / электронных денежных средств и при выплате выигрыша, получении страховой премии или при страховой выплате.
    //ClientINN: "502906602876",
    // Aдрес электронной почты отправителя чека, Тег ОФД 1117 (если задан при регистрации можно не указывать)
    // Формат: Email {С}@{C}
    //SenderEmail: "sochi@mama.com",
    // Место расчетов, Тег ОФД 1187 (если не задано - берется из регистрационных данных ККТ)
    //PlaceMarket: "kkmserver.ru",
    // Система налогообложения (СНО) применяемая для чека, Тег 1055
    // Если не указанно - система СНО настроенная в ККМ по умолчанию
    // 0: Общая ОСН
    // 1: Упрощенная УСН (Доход)
    // 2: Упрощенная УСН (Доход минус Расход)
    // 3: Единый налог на вмененный доход ЕНВД
    // 4: Единый сельскохозяйственный налог ЕСН
    // 5: Патентная система налогообложения
    // Комбинация разных СНО не возможна
    // Надо указывать если ККМ настроена на несколько систем СНО
    TaxVariant: "",

    //ClientId: "557582273e4edc1c6f315efe",
    // Это только для тестов: Получение ключа суб-лицензии : ВНИМАНИЕ: ключ суб-лицензии вы должны генерить у себя на сервере!!!!
    //KeySubLicensing: GetKeySubLicensing("sochi@papa.com", "12qw12"),

    // Если надо одновременно автоматически провести транзакцию через эквайринг
    // Эквайринг будет задействован если: 1. чек фискальный, 2. оплата по "ElectronicPayment" не равна 0, 3. PayByProcessing = true
    // Использовать эквайринг: Null - из настроек на сервере, false - не будет, true - будет
    PayByProcessing: false, //В тестовом чеке автоматический эквайринг выключен
    // Номер устройства для эквайринга - Null - из настроек на сервере, 0 - любое, число - номер конкретного устройства
    NumDeviceByProcessing: null,
    // Номер чека для эквайринга
    ReceiptNumber: options.receiptNumber,
    // Печатать Слип-чек после чека (а не в чеке)
    PrintSlipAfterCheck: false,
    // Печатать Слип-чек дополнительно для кассира (основной слип-чек уже будет печататся в составе чека)
    PrintSlipForCashier: true,
    //Если это чек возврата то возможны два поля для отмены транзакции (если не указано то по эквайрингу будет не отмена а возврат оплаты)
    RRNCode: options.RRNCode, // RRNCode из операции эквайринга. Только для отмены оплаты! Для Оплаты или возврата оплаты не заполнять!
    AuthorizationCode: options.authorizationCode, // AuthorizationCode из операции эквайринга. Только для отмены оплаты! Для Оплаты или возврата оплаты не заполнять!

    // // Признак агента. Тег ОФД 1057. Поле не обязательное. Можно вообще не указывать.
    // // 0: "Банковский платежный агент:" Оказание услуг пользователем, являющимся банковским платежным агентом
    // // 1: "Банковский платежный субагент:" Оказание услуг пользователем, являющимся банковским платежным субагентом
    // // 2: "Платежный агент:" Оказание услуг пользователем, являющимся платежным агентом
    // // 3: "Платежный субагент:" Оказание услуг пользователем, являющимся платежным субагентом
    // // 4: "Поверенный:" Оказание услуг пользователем, являющимся поверенным
    // // 5: "Комиссионер:" Оказание услуг пользователем, являющимся комиссионером
    // // 6: "Агент:" Оказание услуг пользователем, являющимся агентом и не являющимся банковским платежным агентом (субагентом), платежным агентом (субагентом), поверенным, комиссионером
    // AgentSign: 2,
    // // Данные агента. Тег ОД 1223.
    // // Поле не обязательное. Обязательно если установлено поле "AgentSign"
    // // Можно вообще не указывать.
    // AgentData: {
    //   // Операция платежного агента, Тег ОФД 1044
    //   PayingAgentOperation: "95315",
    //   // Телефон платежного агента, Тег ОФД 1073
    //   PayingAgentPhone: "+79995554422",
    //   // Телефон оператора по приему платежей, Тег ОФД 1074
    //   ReceivePaymentsOperatorPhone: "", //"+72223334455",
    //   // Телефон оператора перевода, Тег ОФД 1075
    //   MoneyTransferOperatorPhone: "+74447776655",
    //   // Наименование оператора перевода, Тег ОФД 1026
    //   MoneyTransferOperatorName: "ООО Тестовая организация",
    //   // Адрес оператора перевода, Тег ОФД 1005
    //   MoneyTransferOperatorAddress: "Москва, зубовский бульвар 44",
    //   // ИНН оператора перевода, Тег ОФД 1016
    //   MoneyTransferOperatorVATIN: "430601071197",
    // },
    // Данные поставщика платежного агента.
    // Поле не обязательное.
    // PurveyorData: {
    //   // Телефон поставщика тег ОД 1171
    //   PurveyorPhone: "+76662229955",
    // },
    // // Дополнительный реквизит пользователя тег ОФД 1084
    // UserAttribute: {
    //   // Наименование дополнительного реквизита пользователя тег ОД 1085
    //   Name: "Поле-тест",
    //   // Значение дополнительного реквизита пользователя тег ОФД 1086
    //   Value: "Тестовое значение",
    // },
    // // Дополнительный реквизит чека тег 1192
    // AdditionalAttribute: "Тест",

    // Строки чека
    CheckStrings: receiptLines,
    // Наличная оплата (2 знака после запятой), Тег 1031
    //Cash: 800,
    //Cash: sum,
    // Сумма электронной оплаты (2 знака после запятой), Тег 1081
    //ElectronicPayment: 0.01,

    // Сумма из предоплаты (зачетом аванса) (2 знака после запятой), Тег 1215
    AdvancePayment: 0,
    // Сумма постоплатой(в кредит) (2 знака после запятой), Тег 1216
    Credit: 0,
    // Сумма оплаты встречным предоставлением (сертификаты, др. мат.ценности) (2 знака после запятой), Тег 1217
    CashProvision: 0,
  };

  if (options.typeOfPayment === "electronic") {
    Data.ElectronicPayment = sum;
  } else {
    Data.Cash = sum;
  }

  //чек коррекции
  if (
    options.receiptType === 2 || //корректировка продажи/прихода
    options.receiptType === 3 || //корректировка возврата продажи/прихода
    options.receiptType === 12 || // корректировка покупки/расхода;
    options.receiptType === 13 //корректировка возврата покупки/расхода; (>=ФФД 1.1)
  ) {
    //Тип коррекции 0 - самостоятельно 1 - по предписанию, Тег 1173, Только для чеков коррекции!
    Data.CorrectionType = options.CorrectionType;

    // Дата документа основания для коррекции, Тег ОФД 1178, Только для чеков коррекции!
    Data.CorrectionBaseDate = options.CorrectionBaseDate;

    // Номер документа основания для коррекции, Тег ОФД 1179, Только для чеков коррекции!
    Data.CorrectionBaseNumber = options.CorrectionBaseNumber;

    Data.CorrectionBaseName = options.CorrectionBaseName;


    Data.Cash = options.correctionSum;
    Data.ElectronicPayment = 0;
  }


  // Скидываем данные об агенте - т.к.у Вас невярнека ККТ не зарегистрирована как Агент.
  Data.AgentSign = null;
  Data.AgentData = null;
  Data.PurveyorData = null;
  for (var i = 0; i < Data.CheckStrings.length; i++) {
    if (
      Data.CheckStrings[i] != undefined &&
      Data.CheckStrings[i].Register != undefined
    ) {
      Data.CheckStrings[i].Register.AgentSign = null;
      Data.CheckStrings[i].Register.AgentData = null;
      Data.CheckStrings[i].Register.PurveyorData = null;
    }
  }

  // Вызов команды
  ExecuteCommand(
    Data, // Данные команды
    successCB, // Функция выполняемая при успешном соединении
    failCB // Функция выполняемая при ошибке соединения
  );
}

// Получить текущее состояние ККТ.
function KKMGetDataKKT(NumDevice, INN, successCB, failCB) {
  // Подготовка данных команды
  var Data = {
    // Команда серверу
    Command: "GetDataKKT",
    // ИНН ККМ для поиска. Если "" то ККМ ищется только по NumDevice,
    // Если NumDevice = 0 а InnKkm заполнено то ККМ ищется только по InnKkm
    InnKkm: INN,
    // Система налогообложения (СНО) для поиска ККТ, Можно не указывать, или = "" - любое СНО
    TaxVariant: "",
    // Номер устройства. Если 0 то первое не блокированное на сервере
    NumDevice: NumDevice,
    // Уникальный идентификатор команды. Любая строка из 40 символов - должна быть уникальна для каждой подаваемой команды
    // По этому идентификатору можно запросить результат выполнения команды
    // Поле не обязательно
    IdCommand: guid(),
  };

  // Вызов команды
  ExecuteCommand(Data, successCB, failCB);
  // Возвращается JSON:
  //{
  //    "CheckNumber": 8,     // Номер последнего документа
  //    "SessionNumber": 24,  // Номер текущей смены
  //    "LineLength": 48,     // Ширина строки
  //    "URL": "",
  //    "Info": {
  //        "UrlServerOfd": "connect.ofd-ya.ru",
  //        "PortServerOfd": "7790",
  //        "NameOFD": "ООО \"Ярус\" (\"ОФД-Я\")",
  //        "UrlOfd": "",
  //        "InnOfd": "504404744207",
  //        "NameOrganization": "ООО \"Рога и Копыта\"",
  //        "TaxVariant": "0,3,5",                                // Описание смотри в команде KkmRegOfd
  //        "AddressSettle": "109097, Москва, ул. Ильинка, 9",    // Адрес установки
  //        "EncryptionMode": false,
  //        "OfflineMode": true,
  //        "AutomaticMode": false,
  //        "InternetMode": false,
  //        "BSOMode": false,
  //        "ServiceMode": true,
  //        "InnOrganization": "504404744207",
  //        "KktNumber": "0149060006000651",                      // Заводской номер
  //        "FnNumber": "99078900002287",                         // Номер ФН
  //        "RegNumber": "0149060006035849",                      // Регистрационный номер ККТ (из налоговой)
  //        "Command": "",
  //        "FN_IsFiscal": true,
  //        "OFD_Error": "",
  //        "OFD_NumErrorDoc": 32,
  //        "OFD_DateErrorDoc": "2017-01-13T14:56:00",
  //        "FN_DateEnd": "2018-02-01T00:00:00",
  //        "SessionState": 2                                     // Статус сессии 1-Закрыта, 2-Открыта, 3-Открыта, но закончилась (3 статус на старых ККМ может быть не опознан)
  //    },
  //    "Command": "GetDataKKT",
  //    "Error": "",  // Текст ошибки если была - обязательно показать пользователю - по содержанию ошибки можно в 90% случаях понять как ее устранять
  //    "Status": 0   // Ok = 0, Run(Запущено на выполнение) = 1, Error = 2, NotFound(устройство не найдено) = 3, NotRun = 4
  //}
}

// Отменить платеж по платежной карте
function KKMCancelPaymentByPaymentCard(Data, successCallBack, failCallBack) {
  // Вызов команды
  ExecuteCommand(
    Data,
    successCallBack,
    failCallBack,
    305 * 1000
  );

  //Возвращает в JSON-е следущие поля
  //CardNumber - Номер Карты / Данные карты*
  //ReceiptNumber - Номер чека
  //RRNCode - Уникальный код транзакции RRN
  //AuthorizationCode - Код авторизации транзакции
  //Slip - Текст квитанции, сформированный Эквайринговым ПО **
}

// Оплатить платежной картой
function KKMPayByPaymentCard(Data, successCallBack) {
  // Вызов команды
  ExecuteCommand(Data, successCallBack, undefined, 305 * 1000);

  //Возвращает в JSON-е следущие поля
  //CardNumber - Номер Карты / Данные карты*
  //ReceiptNumber - Номер чека
  //КодRRN - Уникальный код транзакции RRN
  //AuthorizationCode - Код авторизации транзакции
  //Slip - Текст квитанции, сформированный Эквайринговым ПО **
}

function KKMOpenShift(options, successCallBack, failCallBack) {
  // Подготовка данных команды
  let data = {
    // Команда серверу
    Command: "OpenShift",
    // Не печатать чек на бумагу
    NotPrint: false,
    // Уникальный идентификатор команды. Любая строка из 40 символов - должна быть уникальна для каждой подаваемой команды
    // По этому идентификатору можно запросить результат выполнения команды
    IdCommand: guid(),
  };

  // Вызов команды
  ExecuteCommand({...data, ...options}, successCallBack, failCallBack);

  // Возвращается JSON:
  //{
  //    "CheckNumber": 1,    // Номер документа
  //    "SessionNumber": 23, // Номер смены
  //    "QRCode": "t=20170904T141100&fn=9999078900002287&i=108&fp=605445600",
  //    "Command": "OpenShift",
  //    "Error": "",  // Текст ошибки если была - обязательно показать пользователю - по содержанию ошибки можно в 90% случаях понять как ее устранять
  //    "Status": 0   // Ok = 0, Run(Запущено на выполнение) = 1, Error = 2, NotFound(устройство не найдено) = 3, NotRun = 4
  //}
}

function KKMReportReceipt(type, options, successCallback, failCallback){
  if(type.toLowerCase() !== 'z' && type.toLowerCase() !== 'x') {
    failCallback('Wrong report type')
    return;
  }
  let reportType;
  switch(type.toLowerCase()) {
    case 'z':
        reportType = 'ZReport';
      break;
    case 'x':
        reportType = 'XReport';
      break;
  }

  // Подготовка данных команды
  let data = {
    // Команда серверу  "ZReport" ИЛИ  "XReport"
    Command: reportType,
    // Уникальный идентификатор команды. Любая строка из 40 символов - должна быть уникальна для каждой подаваемой команды
    // По этому идентификатору можно запросить результат выполнения команды
    // Поле не обязательно
    IdCommand: guid()
  };
  // Вызов команды
  ExecuteCommand({...data, ...options}, successCallback, failCallback);
  // Возвращается JSON:
  //{
  //    "CheckNumber": 1,    // Номер документа
  //    "SessionNumber": 23, // Номер смены
  //    "Command": "ZReport",
  //    "Error": "",  // Текст ошибки если была - обязательно показать пользователю - по содержанию ошибки можно в 90% случаях понять как ее устранять
  //    "Status": 0   // Ok = 0, Run(Запущено на выполнение) = 1, Error = 2, NotFound(устройство не найдено) = 3, NotRun = 4
  //}
}

function KKMCloseShift(options, successCallback, failCallback) {
  // Подготовка данных команды
  let data = {
    // Команда серверу
    Command: "CloseShift",
    // Id устройства. Строка. Если = "" то первое не блокированное на сервере
    IdDevice: "",
    // Не печатать чек на бумагу
    NotPrint: false,
    // Уникальный идентификатор команды. Любая строка из 40 символов - должна быть уникальна для каждой подаваемой команды
    // По этому идентификатору можно запросить результат выполнения команды
    IdCommand: guid(),
  };

  // Вызов команды
  ExecuteCommand({...data, ...options}, successCallback, failCallback);

  // Возвращается JSON:
  //{
  //    "CheckNumber": 1,    // Номер документа
  //    "SessionNumber": 23, // Номер смены
  //    "QRCode": "t=20170904T141100&fn=9999078900002287&i=108&fp=605445600",
  //    "Command": "OpenShift",
  //    "Error": "",  // Текст ошибки если была - обязательно показать пользователю - по содержанию ошибки можно в 90% случаях понять как ее устранять
  //    "Status": 0   // Ok = 0, Run(Запущено на выполнение) = 1, Error = 2, NotFound(устройство не найдено) = 3, NotRun = 4
  //}
}

export {
  KKMPrintReceipt,
  KKMListDevices,
  KKMGetDataKKT,
  KKMCancelPaymentByPaymentCard,
  KKMPayByPaymentCard,
  KKMOpenShift,
  KKMCloseShift,
  KKMReportReceipt
};
